import apiService from './apiService';
import { API_ENDPOINTS } from '../constants/apiConstants';

export const categoryAPI = {
  getAllCategories: async () => {
    const response = await apiService.get(API_ENDPOINTS.CATEGORY.GET_ALL);
    return response.data;
  },
  createCategory: async (data: FormData) => {
    const response = await apiService.uploadFile(API_ENDPOINTS.CATEGORY.CREATE, data);
    return response.data;
  },
  updateCategory: async (id: string, data: FormData) => {
    const response = await apiService.uploadFilePut(`${API_ENDPOINTS.CATEGORY.UPDATE}/${id}`, data);
    return response.data;
  },
  deleteCategory: async (id: string) => {
    const response = await apiService.delete(`${API_ENDPOINTS.CATEGORY.DELETE}/${id}`);
    return response.data;
  },
};